module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Elements of a Better Life")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#introduction-before-the-beginning"
    }
  }, [_vm._v("Introduction Before the Beginning")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#part-one-it-has-begun"
    }
  }, [_vm._v("Part One It Has Begun")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-1-beginnings"
    }
  }, [_vm._v("Chapter 1: Beginnings")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#perspective"
    }
  }, [_vm._v("Perspective")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#life"
    }
  }, [_vm._v("Life")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#vertebrates"
    }
  }, [_vm._v("Vertebrates")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#embryo"
    }
  }, [_vm._v("Embryo")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#software"
    }
  }, [_vm._v("Software")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-2-consciousness"
    }
  }, [_vm._v("Chapter 2: Consciousness")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#dna"
    }
  }, [_vm._v("DNA")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#dinosaurs"
    }
  }, [_vm._v("Dinosaurs")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#savannah"
    }
  }, [_vm._v("Savannah")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#fitness"
    }
  }, [_vm._v("Fitness")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#chapter-3-god"
    }
  }, [_vm._v("Chapter 3: God")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#mathematics"
    }
  }, [_vm._v("Mathematics")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#stretch"
    }
  }, [_vm._v("Stretch")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#fit"
    }
  }, [_vm._v("Fit")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#successful"
    }
  }, [_vm._v("Successful")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#individuality"
    }
  }, [_vm._v("Individuality")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#exams"
    }
  }, [_vm._v("Exams")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#change"
    }
  }, [_vm._v("Change")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-4-movement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Movement")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#nudge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nudge")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-5-bbb-big-bang-brain",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: BBB (Big Bang Brain)")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#perception",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Perception")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#space",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Space")])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#part-two-travel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two Travel")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#about-part-two",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About part two…")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-6-money",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Money")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-7-kandy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Kandy")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#senaradne",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Senaradne")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#rodrigo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rodrigo")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-8-oil",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Oil")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#zayed",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zayed")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#scaffolding",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scaffolding")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#omt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OMT")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#new",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New")])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#part-three-overstretched",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three Overstretched")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-9-pandemic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Pandemic")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#mechanisms",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mechanisms")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#fever",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fever")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-10-deception",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Deception")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#deception",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deception")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-11-flat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Flat")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#qatar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Qatar")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#beirut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beirut")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#beatles",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beatles")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#micro",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Micro")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#debacles",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Debacles")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#elisabeth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elisabeth")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#excerpt-from-the-first-leaflet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpt from the First Leaflet")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#excerpt-from-the-third-leaflet-salus-publica-suprema-lex",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpt from the Third Leaflet Salus publica suprema lex")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#excerpt-from-the-fifth-leaflet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpt from the Fifth Leaflet")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-12-stress",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Stress")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#negative",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Negative")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#thermostat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thermostat")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#energy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Energy")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#damage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Damage")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#pathways",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pathways")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#nervous",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nervous")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#lifestyle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lifestyle")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-13-sick",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Sick")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#lifestyle-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lifestyle")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#core",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Core")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#society",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Society")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-14-injured",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Injured")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#young",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Young")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#network",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Network")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#switch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Switch")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#distracted",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Distracted")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#performance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Performance")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#sum",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sum")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#rehabilitation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rehabilitation")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#grateful",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grateful")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-15-perfectionism",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Perfectionism")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#stretch-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stretch")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#grindstone",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grindstone")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#mediocre",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mediocre")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#intravenous",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intravenous")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#parentification",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parentification")])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#part-four-balance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four Balance")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#about-part-four",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About part four…")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-87"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#chapter-16-sugar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Sugar")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#obesity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Obesity")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-89"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#norm",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Norm")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#cause",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cause")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-91"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#effects",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Effects")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-92"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#solution",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solution")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-93"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#chapter-17-alcohol",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Alcohol")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-94"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#meteor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meteor")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-95"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#best",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Best")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-96"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#lifestyle-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lifestyle")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-97"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#chapter-18-cocaine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Cocaine")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-98"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#pervitin",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pervitin")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-99"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#brain",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brain")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-100"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#future",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Future")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-101"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#chapter-19-tobacco",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Tobacco")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-102"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#ingredients",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-103"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#sweetness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweetness")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-104"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#mafia",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mafia")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-105"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-106"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#chapter-20-plastic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Plastic")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-107"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#development",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Development")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-108"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#roadside",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roadside")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-109"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#nanoparticles",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nanoparticles")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-110"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#immunity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Immunity")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-111"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#tyres",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tyres")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-112"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#context",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Context")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-113"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#future-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Future")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-114"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#grass",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grass")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-115"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#chapter-21-heat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Heat")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-116"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#marcus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marcus")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-117"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#logistics",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Logistics")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-118"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#redefined",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Redefined")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-119"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#chapter-22-exhausted",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Exhausted")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-120"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#burnout",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Burnout")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-121"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#boomerang",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boomerang")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-122"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#vicious",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vicious")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-123"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#views-on-ageing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Views on Ageing")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-124"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#how-to-stay-young",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Stay Young")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-125"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#and-always-remember",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AND ALWAYS REMEMBER:")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-126"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#chapter-23-development",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: Development")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-127"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#chapter-24-school",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: School")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-128"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#cello",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cello")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-129"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#learning",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Learning")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-130"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#chelsea",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chelsea")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-131"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#pyrenees",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pyrenees")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-132"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#wealth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wealth")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-133"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#model",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Model")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-134"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#fake",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fake")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-135"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#sum-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sum")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-136"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#chapter-25-digital",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: Digital")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-137"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#visual",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visual")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-138"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#isolation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isolation")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-139"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#offline",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Offline")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-140"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#safety",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Safety")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-141"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#chapter-26-office",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: Office")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-142"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#trending",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trending")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-143"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#entrepreneurs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Entrepreneurs")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-144"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#lounge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lounge")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-145"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#climate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Climate")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-146"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#points",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Points")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-147"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#presentation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Presentation")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-148"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#spiderweb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spiderweb")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-149"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#chapter-27-productivity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27: Productivity")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-150"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#fit-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fit")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-151"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#pioneer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pioneer")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-152"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#layout",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Layout")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-153"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#variety",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Variety")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-154"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#universal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Universal")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-155"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#break",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Break")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-156"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#opportunity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Opportunity")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-157"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#chapter-28-leadership",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28: Leadership")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-158"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#work-floor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Work floor")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-159"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#why",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Why")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-160"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#new-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-161"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#chapter-29-workforce",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29: Workforce")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-162"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#networks",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Networks")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-163"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#tests",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tests")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-164"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#psychology",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psychology")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-165"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#listening",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Listening")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-166"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#cognition",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cognition")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-167"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#business",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Business")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-168"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#chapter-30-talent",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30: Talent")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-169"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#treatment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Treatment")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-170"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#chapter-31-walking",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31 Walking")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-171"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#well-being",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Well-being")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-172"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#bio-walks",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bio-walks")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-173"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#parx",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PARX")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-174"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#change-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Change")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-175"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#korbi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Korbi")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-176"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#physiotherapy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Physiotherapy")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-177"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#mathilde",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mathilde")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-178"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#sanctuary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sanctuary")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-179"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#chapter-32-menagerie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32: Menagerie")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-180"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#anthro",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anthro")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-181"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#treatment-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Treatment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-182"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#shepherd",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shepherd")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-183"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#merino",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Merino")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-184"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#pure",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pure")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-185"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#answer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Answer")])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-186"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#part-five-arrival",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Five Arrival")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-187"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#chapter-33-landed",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33: Landed")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-188"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#brain-dna",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brain DNA")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-189"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#disruption",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Disruption")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-190"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#roses",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roses")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-191"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#sadernes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sadernes")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-192"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#landed",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Landed")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-193"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#return",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Return")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-194"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#chapter-34-aligned",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34: Aligned")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-195"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#psychological-status",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psychological Status")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-196"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#livingworking-environment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Living/Working Environment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-197"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#organism",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Organism")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-198"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#alignment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alignment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-199"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#connected",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Connected")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-200"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#aurelius",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aurelius")])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-246b895e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0